"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openIntegrationServiceFail = exports.openIntegrationServiceSuccess = exports.openIntegrationService = exports.updateIntegrationFail = exports.updateIntegrationSuccess = exports.updateIntegration = exports.disconnectFromIntegrationFail = exports.disconnectFromIntegrationSuccess = exports.disconnectFromIntegration = exports.getActiveIntegrationFail = exports.getActiveIntegrationSuccess = exports.getActiveIntegration = void 0;

var _reduxAct = require("redux-act");

var PREFIX = 'COMMON/PERSONAL/INTEGRATIONS';
var getActiveIntegration = (0, _reduxAct.createAction)("".concat(PREFIX, "/GET_ACTIVE_INTEGRATION_REQUEST"));
exports.getActiveIntegration = getActiveIntegration;
var getActiveIntegrationSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/GET_ACTIVE_INTEGRATION_SUCCESS"));
exports.getActiveIntegrationSuccess = getActiveIntegrationSuccess;
var getActiveIntegrationFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/GET_ACTIVE_INTEGRATION_FAIL"));
exports.getActiveIntegrationFail = getActiveIntegrationFail;
var disconnectFromIntegration = (0, _reduxAct.createAction)("".concat(PREFIX, "/DISCONNECT_FROM_INTEGRATION_REQUEST"));
exports.disconnectFromIntegration = disconnectFromIntegration;
var disconnectFromIntegrationSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/DISCONNECT_FROM_INTEGRATION_SUCCESS"));
exports.disconnectFromIntegrationSuccess = disconnectFromIntegrationSuccess;
var disconnectFromIntegrationFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/DISCONNECT_FROM_INTEGRATION_FAIL"));
exports.disconnectFromIntegrationFail = disconnectFromIntegrationFail;
var updateIntegration = (0, _reduxAct.createAction)("".concat(PREFIX, "/UPDATE_INTEGRATION_REQUEST"));
exports.updateIntegration = updateIntegration;
var updateIntegrationSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/UPDATE_INTEGRATION_SUCCESS"));
exports.updateIntegrationSuccess = updateIntegrationSuccess;
var updateIntegrationFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/UPDATE_INTEGRATION_FAIL"));
exports.updateIntegrationFail = updateIntegrationFail;
var openIntegrationService = (0, _reduxAct.createAction)("".concat(PREFIX, "/OPEN_INTEGRATION_SERVICE_REQUEST"), function () {
  return undefined;
}, function (_ref) {
  var service = _ref.service,
      _ref$script = _ref.script,
      script = _ref$script === void 0 ? '' : _ref$script,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? '' : _ref$path,
      _ref$scopes = _ref.scopes,
      scopes = _ref$scopes === void 0 ? {} : _ref$scopes;
  return {
    service,
    script,
    path,
    scopes
  };
});
exports.openIntegrationService = openIntegrationService;
var openIntegrationServiceSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/OPEN_INTEGRATION_SERVICE_SUCCESS"));
exports.openIntegrationServiceSuccess = openIntegrationServiceSuccess;
var openIntegrationServiceFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/OPEN_INTEGRATION_SERVICE_FAIL"));
exports.openIntegrationServiceFail = openIntegrationServiceFail;